import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M23.7 16.2a1 1 0 00-1.5 0L17 21.5V8a1 1 0 10-2 0v13.5l-5.2-5.3a1 1 0 00-1.5 0 1 1 0 000 1.5l6.9 7a1 1 0 00.8.3 1.1 1.1 0 00.8-.3l6.9-7a1 1 0 000-1.5z"/><path d="M4 16a12 12 0 1112 12A12 12 0 014 16m-2 0A14 14 0 1016 2 14 14 0 002 16z"/>';
export var ArrowDownCircleOutlineSVG = function ArrowDownCircleOutlineSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
ArrowDownCircleOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(ArrowDownCircleOutlineSVG);